import { Injectable, Inject } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthenticationService } from "../service/authentication.service";

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {

  constructor(private readonly authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authenticationService.getToken()) {
 
      return next.handle(this.addAccessTokenToRequest(request));
    }
    return next.handle(request);
  }

  private addAccessTokenToRequest(request: HttpRequest<any>): HttpRequest<any> {
    const accessToken = this.authenticationService.getToken();
    if (accessToken) {
      return request.clone({
        setHeaders: {
          "Authorization": `Bearer ${accessToken}`,
        }
      });
    }
    return request;
  }
}
